module.exports = __webpack_public_path__ + "static/media/slide1.d2d5b728.jpg";